module.exports = __webpack_public_path__ + "assets/img/qqIcon.bcf231ec.png";